import React, { useContext, useEffect, useState } from 'react';
import { AnimatedEllipsis } from '..';
import { Context } from '../../context/dataStore';
import './OrgInfo.scss';

/**
 * This component finds and renders the current organization's information
 * 
 * @param {string} org_id - organization's id (collected from the Category page's URL)
 * @returns formatted and styled organization's information
 */
export const OrgInfo = ({ org_id }) => {

    //get orgData array from context, pre-populated whenever the Category page is loaded
    const { state: { orgData } } = useContext(Context);
    const [currentOrg, setCurrentOrg] = useState({});

    //Using org_id to find current organization from orgData array
    useEffect(() => {
        if (orgData.length) {
            setCurrentOrg(orgData?.find(el => parseInt(el.org_id) === parseInt(org_id)));
        }
    }, [orgData, org_id]);

    //This is a component utilized by the main component to format the current organization's (currentOrg) details
    const OrgDetails = ({ orgDetails }) => {
        return (
            <div id={`mycb-orginfo${org_id}_body`}>
                <p className='mycb-orginfo-text'>
                    Name: <span className='bolddescription'>{orgDetails?.org_name}</span>
                </p>
                <p className='mycb-orginfo-text'>
                    Type: <span className='bolddescription'>{orgDetails?.type}</span>
                </p>
                <p className='mycb-orginfo-text'>
                    Address: <span className='bolddescription'>{`${orgDetails?.street_address}, ${orgDetails?.city}, ${orgDetails?.state} ${orgDetails?.postal_code} ${orgDetails?.country}`}</span>
                </p>
            </div>
        );
    };
    // This is the main component that renders the appropriate text and implements the orgDetails component
    // If no organization is found based on the given org_id animated ellipses will render instead of the OrgDetails
    return (
        <div className='mycb-orginfo' role='region' aria-labelledby={`cdscard_${org_id}_header`}>
            <div className='mycb-orginfo-content'>
                <div id={`mycb_orginfo${org_id}_header`}>
                    <h2 className='mycb-orginfo-header'> Your Institution:</h2>
                </div>
                <div class='mycb-orginfo-text bolddescription' id={`mycb_orginfo${org_id}_form`}>
                To update your institution name and/or street address (physical address) information, please submit the request via the{' '}
                <a href='http://scoresendcode.collegeboard.org' aria-describedby={`mycb-orginfo-link${org_id}`} className='mycb-orginfo-link'>
                Score Send Code Request Form
                </a>
                . By submitting through this process, all College Board consumers will have the updated information with your DI Code, name and address. Requests are processed in the order received. Note: Requests to update an institution’s name must be verified with accreditation.
                </div>
                <br />
                {/* Using currentOrg.org_id because currentOrg has a tendency to approve undefined details */}
                {currentOrg?.org_id ? (
                    <OrgDetails orgDetails={currentOrg} />
                ) : (
                    <div className='centerEllipsis'>
                        <AnimatedEllipsis />
                    </div>
                )}
            </div>
        </div>
    );
};
